<template>
  <v-container>
    <h2>Dropdown Setting</h2>
    <v-container class="d-flex justify-center">
      <v-card elevation="0" class="rounded-xl" width="50%">
        <v-card-text class="d-flex align-center">
          <v-autocomplete
            rounded
            outlined
            label="Dropdown"
            class="mr-2"
            :item-text="getDropdownText"
            item-value="strRef"
            :items="dropdowns"
            v-model="dropdownStr"
            hide-details
          ></v-autocomplete>
          <v-btn
            depressed
            rounded
            color="primary"
            @click="openDropdownOptionDialog"
            :disabled="dropdownStr.length == 0"
            >Add
          </v-btn>
        </v-card-text>
      </v-card></v-container
    >
    <v-container v-if="dropdownStr.length != 0" class="d-flex justify-center">
      <v-card elevation="0" class="rounded-xl" width="50%">
        <v-card-text>
          <v-list dense>
            <template v-for="(option, idx) in options">
              <div :key="option.id">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-container
                        class="d-flex justify-space-between align-center pa-0"
                        ><v-text-field
                          class="mr-2"
                          rounded
                          outlined
                          dense
                          v-model="option.displayName"
                          hide-details
                        ></v-text-field>
                        <v-text-field
                          class="mr-2"
                          rounded
                          outlined
                          dense
                          v-model="option.customEnum"
                          hide-details
                        ></v-text-field>
                        <div class="d-flex">
                          <v-btn
                            depressed
                            rounded
                            color="warning"
                            class="mr-2"
                            @click="updateDropdownOption(option)"
                            :loading="toUpdateId == option.id"
                            >Update</v-btn
                          >
                          <v-btn
                            depressed
                            rounded
                            color="error"
                            @click="updateDropdownOption(option, true)"
                            :loading="toDeleteId == option.id"
                            :disabled="option.customEnum"
                            >Delete</v-btn
                          >
                        </div></v-container
                      >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="idx != options.length - 1"></v-divider>
              </div>
            </template> </v-list
        ></v-card-text>
      </v-card>
    </v-container>
  </v-container>
</template>
<script>
import backendService from "@/services/backend-service.js";
import generalMixin from "@/js/general-mixin.js";
import eventBus from "@/js/event-bus.js";
export default {
  name: "DropdownSetting",
  mixins: [generalMixin],
  mounted() {
    backendService.getDropdowns().then((response) => {
      this.dropdowns = response.data;
    });
  },
  data() {
    return { dropdowns: [], dropdownStr: "", toUpdateId: -1, toDeleteId: -1 };
  },
  computed: {
    dropdownToOptions() {
      return this.$store.getters["dropdownToOptions"];
    },
    options() {
      if (this.dropdownToOptions[this.dropdownStr]) {
        return this.dropdownToOptions[this.dropdownStr].options;
      }
      return [];
    },
  },
  methods: {
    getDropdownText(dropdown) {
      let dropdownText = dropdown.displayName;
      if (dropdown.description) {
        dropdownText += ` - ${dropdown.description}`;
      }
      return dropdownText;
    },
    getDropdownId() {
      return this.dropdownToOptions[this.dropdownStr].id;
    },
    openDropdownOptionDialog() {
      eventBus.$emit("setDropdownOptionDialog", this.getDropdownId());
    },
    updateDropdownOption(option, isDeleting = false) {
      if (isDeleting) {
        option.isActive = false;
        this.toDeleteId = option.id;
      } else {
        this.toUpdateId = option.id;
      }
      backendService.updateDropdownOption(option).then(() => {
        this.timer(1000).then(() => {
          if (isDeleting) {
            let options = this.dropdownToOptions[this.dropdownStr].options;
            let idx = options.findIndex((e) => e.id == this.toDeleteId);
            options.splice(idx, 1);
            this.toDeleteId = -1;
            this.successSnackbar("Successfully deleted option");
          } else {
            this.toUpdateId = -1;
            this.successSnackbar("Successfully updated option");
          }
        });
      });
    },
  },
};
</script>
